import React from "react";
import { useSelector } from "react-redux";
import { selectData } from "../pages/homeSlice";
import styled from "styled-components";
// Data
import { Blog } from "../data";
// Icons
import { FaGithub } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";


const StyledSocialLinks = styled.div`
  a {
    margin: 0 1rem;
  }
`;

export default function SocialLinks() {
  const { blog, html_url } = useSelector(selectData);

  return (
    <StyledSocialLinks>
      <a
        href={html_url}
        aria-label="Check out my GitHub profile."
        className="link-icons"
      >
        <FaGithub />
      </a>

      <a
        href="https://www.linkedin.com/in/nfalvarezg/"
        aria-label="Check out my Linkedin."
        className="link-icons"
      >
        <FaLinkedin />
      </a>

      <a
        href="https://www.youtube.com/nescool101"
        aria-label="Check out my Youtube."
        className="link-icons"
      >
        <FaYoutube />
      </a>

      <a
        href="https://www.facebook.com/nescool111"
        aria-label="Check out my Facebook."
        className="link-icons"
      >
        <FaFacebook />
      </a>

      {blog && (
        <a href={blog} aria-label="External link" className="link-icons">
          {Blog}
        </a>
      )}
    </StyledSocialLinks>
  );
}
